export type NormalizedCrop = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export function cropForFocus(input: {
  sourceWidth: number;
  sourceHeight: number;
  targetWidth: number;
  targetHeight: number;
  focusX: number;
  focusY: number;
  zoom: number;
}): NormalizedCrop {
  const sourceRatio = input.sourceWidth / input.sourceHeight;
  const targetRatio = input.targetWidth / input.targetHeight;
  const boundedZoom = Math.max(1, input.zoom);
  const maximum =
    sourceRatio > targetRatio
      ? { width: targetRatio / sourceRatio, height: 1 }
      : { width: 1, height: sourceRatio / targetRatio };
  const width = maximum.width / boundedZoom;
  const height = maximum.height / boundedZoom;
  return {
    x: clamp(input.focusX - width / 2, 0, 1 - width),
    y: clamp(input.focusY - height / 2, 0, 1 - height),
    width,
    height,
  };
}

export function cropPixelSize(crop: NormalizedCrop, source: { width: number; height: number }) {
  return {
    width: Math.round(crop.width * source.width),
    height: Math.round(crop.height * source.height),
  };
}

function clamp(value: number, minimum: number, maximum: number) {
  return Math.min(maximum, Math.max(minimum, value));
}
